import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useLang } from "../i18n/LanguageContext";
import api, { formatApiErrorDetail } from "../lib/api";
import { BridgeMark } from "../components/BridgeMotif";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (nw !== cf) { setError(t("reset.mismatch")); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: nw });
      toast.success(t("reset.success"));
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16">
      <BridgeMark size={40} />
      <h1 className="mt-4 font-display text-2xl font-bold tracking-tight text-slateink">{t("reset.title")}</h1>
      {!token ? (
        <p className="mt-6 rounded-xl border border-border bg-white px-4 py-6 text-center text-sm text-muted-foreground" data-testid="reset-invalid">{t("reset.invalid")}</p>
      ) : (
        <form onSubmit={submit} className="mt-6 w-full space-y-4 rounded-2xl border border-border bg-white p-7" data-testid="reset-form">
          {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="reset-error">{error}</p>}
          <div>
            <Label>{t("reset.new_password")}</Label>
            <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} required minLength={8} data-testid="reset-new-password" />
            <p className="mt-1 text-xs text-muted-foreground">{t("reset.hint")}</p>
          </div>
          <div>
            <Label>{t("reset.confirm_password")}</Label>
            <Input type="password" value={cf} onChange={(e) => setCf(e.target.value)} required data-testid="reset-confirm-password" />
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-full bg-terracotta hover:bg-terracotta-hover" data-testid="reset-submit">
            {busy ? t("common.saving") : t("reset.submit")}
          </Button>
        </form>
      )}
      <p className="mt-6 text-sm text-muted-foreground"><Link to="/login" className="font-medium text-terracotta hover:underline">{t("auth.login_here")}</Link></p>
    </div>
  );
}
